import Seo from "../components/apps/Seo";
import { Link } from "react-router-dom";
import { apps } from "../data/apps";
import {
  AppIcon,
  AppStoreBadge,
  FloatingHas,
  Stars,
  body,
  display,
} from "../components/apps/AppBits";

export default function AppsPage() {
  return (
    <main style={body} className="bg-[#FFF9F2] min-h-screen">
          <Seo
            title="iOS Apps by Zinnobyte App Studio — Guffaw & More"
            description="Playful iOS apps from Zinnobyte: Guffaw funny photo & video booth with 75 face effects, and Laugh With Me laughing yoga. Free on the App Store."
            path="/apps"
          />
      {/* ----------------------------------------------------------- hero */}
      <section
        className="relative overflow-hidden text-white"
        style={{
          background:
            "linear-gradient(120deg, #241663 0%, #7C2D8E 42%, #B33FA0 68%, #FF8A3D 100%)",
        }}
      >
        <FloatingHas />
        <div className="relative max-w-6xl mx-auto px-6 pt-20 pb-24 md:pt-28 md:pb-32">
          <p
            className="inline-block rounded-full border border-white/40 px-4 py-1 text-xs tracking-[0.2em] mb-6"
            style={display}
          >
            ✦ ZINNOBYTE APP STUDIO
          </p>
          <h1
            style={display}
            className="text-4xl md:text-6xl font-semibold leading-[1.05] max-w-2xl"
          >
            Apps built to make
            <br />
            you <span className="text-[#FFC93D]">laugh out loud.</span>
          </h1>
          <p className="mt-5 max-w-lg text-white/85 text-lg">
            We're an indie studio crafting playful iOS apps — from face-bending
            camera booths to guided laughing yoga.
          </p>
          <a
            href="#our-apps"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FF5C39] px-7 py-3 font-semibold text-white transition-transform hover:scale-[1.04] active:scale-[0.98]"
            style={display}
          >
            Explore our apps <span aria-hidden>→</span>
          </a>
        </div>
        {/* laughter-wave divider into the cream section */}
        <svg
          aria-hidden
          viewBox="0 0 1440 70"
          className="block w-full text-[#FFF9F2]"
          preserveAspectRatio="none"
        >
          <path
            fill="currentColor"
            d="M0 45 Q 60 15 120 45 T 240 45 T 360 45 T 480 45 T 600 45 T 720 45 T 840 45 T 960 45 T 1080 45 T 1200 45 T 1320 45 T 1440 45 V 70 H 0 Z"
          />
        </svg>
      </section>

      {/* ------------------------------------------------------ app cards */}
      <section id="our-apps" className="max-w-6xl mx-auto px-6 py-16 md:py-20">
        <p className="text-sm tracking-[0.2em] text-[#B33FA0] font-bold mb-2">
          OUR APPS
        </p>
        <h2 style={display} className="text-3xl md:text-4xl font-semibold text-[#241633]">
          Made with care. <span className="text-[#FF5C39]">Shipped with a grin.</span>
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {apps.map((app) => (
            <article
              key={app.slug}
              className="group relative rounded-3xl bg-white border border-[#F0E7DA] p-7 transition-shadow hover:shadow-[0_24px_50px_-24px_rgba(36,22,51,0.35)]"
            >
              {app.status === "coming-soon" && (
                <span
                  style={display}
                  className="absolute top-6 right-6 rounded-full bg-[#F1EBFF] text-[#6236C9] text-xs font-semibold px-3 py-1"
                >
                  In development
                </span>
              )}
              <div className="flex items-center gap-4">
                <AppIcon app={app} size={72} />
                <div>
                  <h3 style={display} className="text-xl font-semibold text-[#241633]">
                    {app.name}
                  </h3>
                  <p className="text-sm text-[#8A7F70]">{app.subtitle}</p>
                  <p className="text-xs mt-1 font-semibold" style={{ color: app.gradient[1] }}>
                    {app.category}
                  </p>
                </div>
              </div>

              <p className="mt-4 text-[#4A4238] leading-relaxed">{app.tagline}</p>

              {app.rating ? (
                <p className="mt-3 flex items-center gap-2 text-sm text-[#8A7F70]">
                  <Stars value={app.rating} />
                  <span className="font-semibold text-[#241633]">{app.rating}</span>
                  <span>· {app.ratingCount}</span>
                </p>
              ) : (
                <p className="mt-3 text-sm text-[#8A7F70]">
                  Launching soon on the App Store
                </p>
              )}

              <div className="mt-5 flex flex-wrap items-center gap-3">
                <Link
                  to={`/apps/${app.slug}`}
                  className="inline-flex items-center gap-1.5 rounded-full border-2 px-5 py-2 text-sm font-semibold transition-colors"
                  style={{
                    ...display,
                    borderColor: app.gradient[1],
                    color: app.gradient[1],
                  }}
                >
                  View app <span aria-hidden>→</span>
                </Link>
                {app.appStoreUrl && <AppStoreBadge href={app.appStoreUrl} />}
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
